import React from 'react';
import classNames from 'classnames';
import styles from '../styles/components/GridTable.scss';

const GridTable = ({ input, meta, rows, cols }) => {
  const cellsObj = input.value || {};

  const matrix = Array.from({ length: rows }, (_, r) =>
    Array.from({ length: cols }, (_, c) => {
      const colLetter = String.fromCharCode(65 + c);
      const key = `${colLetter}${r + 1}`;
      return {
        key,
        value: cellsObj[key] || '',
      };
    })
  );

  const handleChange = (key, value) => {
    input.onChange({
      ...cellsObj,
      [key]: value,
    });
  };

  const handleBlur = (key, value) => {
    input.onBlur({
      ...cellsObj,
      [key]: value,
    });
  };

  return (
    <div className={styles.wrapper}>
      {matrix.map((row, r) => (
        <div key={r} className={styles.row}>
          {row.map(({ key, value }) => {
            const cellError = meta.error?.[key];
            const cellTouched = meta.touched;
            const hasError = cellTouched && cellError;

            return (
              <div
                key={key}
                className={classNames(styles.cell, hasError && styles.error)}
              >
                <input
                  placeholder={key}
                  value={value}
                  onChange={(e) => handleChange(key, e.target.value)}
                  onBlur={(e) => handleBlur(key, e.target.value)}
                />
                {/* {hasError && (
                  <span className={styles.errorText}>{cellError}</span>
                )} */}
              </div>
            );
          })}
        </div>
      ))}
    </div>
  );
};

export default GridTable;
